import React from 'react';
import { Controller } from 'react-hook-form';
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';

const OPTIONS = ['Dr.', 'Miss', 'Mr.', 'Mrs.', 'Ms.', 'Mx.'];

function ControlledPrefixInput({
  FormHelperTextProps,
  className,
  control,
  defaultValue,
  helperText,
  label,
  name,
  rules,
  ...props
}) {
  return (
    <FormControl>
      <Controller
        {...(defaultValue && { defaultValue })}
        name={name}
        control={control}
        rules={rules}
        render={({ field: { onChange, ...rest } }) => (
          <Autocomplete
            {...props}
            {...rest}
            onInputChange={(e, newVal) => onChange(newVal)}
            classes={{ root: className }}
            options={OPTIONS}
            freeSolo
            renderInput={(params) => (
              <TextField fullWidth label={label} {...params} />
            )}
          />
        )}
      />

      {helperText && (
        <FormHelperText {...FormHelperTextProps}>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
}

ControlledPrefixInput.propTypes = {
  FormHelperTextProps: PropTypes.shape({
    className: PropTypes.string,
  }),
  className: PropTypes.string,
  control: PropTypes.object.isRequired,
  defaultValue: PropTypes.string,
  helperText: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  rules: PropTypes.object,
};

ControlledPrefixInput.defaultProps = {
  FormHelperTextProps: {},
  className: '',
  defaultValue: '',
  helperText: '',
  label: '',
  rules: {},
};

export default ControlledPrefixInput;
